'use client';
import classNames from 'classnames';
import React, { FC, useState } from 'react';

import { useTranslation } from '@/hooks/useTranslations';
import './styles.scss';

type NewFaqProps = {
  questions: {
    question: string;
    answer: string;
  }[];
  title: string;
};

const NewFaq: FC<NewFaqProps> = ({ questions, title }) => {
  const [openIndex, setOpenIndex] = useState<number>(-1);
  const { t } = useTranslation();

  return (
    <div className="new-faq-wrapper">
      <h2 className="new-faq-title">{t(title)}</h2>
      <div className="new-faq-content">
        {questions.map((item, index) => (
          <div
            key={item.question}
            className={classNames('new-faq-row-wrapper', { open: openIndex === index })}
            onClick={() => setOpenIndex(openIndex === index ? -1 : index)}
          >
            <div className="new-faq-row-inner">
              <p className="new-faq-row-inner-title">{t(item.question)}</p>
              <i className="bc-i-arrow-down new-faq-arrow-icon" />
            </div>
            <div className="new-faq-row-open">
              <div className="new-faq-row-open-holder">
                <div className="new-faq-row-open-inner">
                  <p className="new-faq-row-open-desc">{t(item.answer)}</p>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default NewFaq;
